module.exports = __webpack_public_path__ + "img/BF7745_F5D08E_E5AE6B_ECBC7C-256px.525df95a.png";